import { render, staticRenderFns } from "./bothFloat.vue?vue&type=template&id=88448adc&scoped=true&"
import script from "./bothFloat.vue?vue&type=script&lang=js&"
export * from "./bothFloat.vue?vue&type=script&lang=js&"
import style0 from "./bothFloat.vue?vue&type=style&index=0&id=88448adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88448adc",
  null
  
)

export default component.exports